"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadRecordFyErrorSheetApi = downloadRecordFyErrorSheetApi;
exports.downloadRecordGivingErrorSheetApi = downloadRecordGivingErrorSheetApi;
exports.importRecordsApi = importRecordsApi;
exports.importRecordsFyDownloadsApi = importRecordsFyDownloadsApi;
exports.importRecordsValidationApi = importRecordsValidationApi;
exports.recordsValidationErrorDownloadApi = recordsValidationErrorDownloadApi;
exports.updateRecordGivingsApi = updateRecordGivingsApi;
exports.validateRecordFyDownloadApi = validateRecordFyDownloadApi;
exports.validateRecordGivingsApi = validateRecordGivingsApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * validation
 * @param payload
 * @returns api response
 * @description this function used to validate data.
 */
function importRecordsValidationApi(payload) {
  return api.createWithParamBody("".concat(_app.default.baseUrl + _dashboard.ImportService.recordImport.importRecordsValidation), payload.params, payload.data);
}

/**
 * validate record givings
 * @param payload
 * @returns api response
 * @description this function used to validate record givings data.
 */
function validateRecordGivingsApi(payload) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ImportService.recordImport.validateRecordGivings), payload);
}

/**
 * validate record fy download
 * @param payload
 * @returns api response
 * @description this function used to validate record fy download data.
 */
function validateRecordFyDownloadApi(payload) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ImportService.recordImport.validateRecordFyDownload), payload);
}

/**
 * import records
 * @param payload
 * @returns api response
 * @description this function used to import records data.
 */
function importRecordsApi(payload) {
  return api.createWithParamBody("".concat(_app.default.baseUrl + _dashboard.ImportService.recordImport.importRecords), payload.params, payload.data);
}

/**
 * import records fy downloads
 * @param payload
 * @returns api response
 * @description this function used to import records fy downloads data.
 */
function importRecordsFyDownloadsApi(payload) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ImportService.recordImport.importRecordsFyDownloads), payload);
}

/**
 * update record givings
 * @param payload
 * @returns api response
 * @description this function used to update record givings data.
 */
function updateRecordGivingsApi(payload) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ImportService.recordImport.updateRecordGivings), payload);
}

/**
 * validation error download
 * @param payload
 * @returns api response
 * @description this function used to validation error download data.
 */
function recordsValidationErrorDownloadApi(params) {
  return api.getFile("".concat(_app.default.baseUrl + _dashboard.ImportService.recordImport.recordsValidationErrorDownload), params);
}

/**
 * download vrecord giving error sheet
 * @param payload
 * @returns api response
 * @description this function used to download vrecord giving error sheet data.
 */
function downloadRecordGivingErrorSheetApi(params) {
  return api.getFile("".concat(_app.default.baseUrl + _dashboard.ImportService.recordImport.downloadRecordGivingErrorSheet), params);
}

/**
 * download vrecord giving error sheet
 * @param payload
 * @returns api response
 * @description this function used to download vrecord giving error sheet data.
 */
function downloadRecordFyErrorSheetApi(params) {
  return api.getFile("".concat(_app.default.baseUrl + _dashboard.ImportService.recordImport.recordsFyValidationErrorDownload), params);
}